var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagesQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 3H6C4.35 3 3 4.35 3 6V33L9 27H30C31.65 27 33 25.65 33 24V6C33 4.35 31.65 3 30 3ZM19.5 21H16.5V18H19.5V21ZM22.2 13.5C21.75 14.1 21.15 14.4 20.55 14.7C20.1 15 19.95 15.15 19.8 15.45C19.5 15.75 19.5 16.05 19.5 16.5H16.5C16.5 15.75 16.65 15.3 16.95 14.85C17.25 14.55 17.85 14.1 18.6 13.65C19.05 13.5 19.35 13.2 19.5 12.9C19.65 12.6 19.8 12.15 19.8 11.85C19.8 11.4 19.65 11.1 19.35 10.8C19.05 10.5 18.6 10.35 18.15 10.35C17.7 10.35 17.4 10.5 17.1 10.65C16.8 10.8 16.65 11.1 16.65 11.55H13.65C13.8 10.5 14.25 9.6 15 9C15.75 8.4 16.8 8.25 18.15 8.25C19.5 8.25 20.7 8.55 21.45 9.15C22.2 9.75 22.65 10.65 22.65 11.7C22.8 12.3 22.65 12.9 22.2 13.5Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesQuestion);
export default __webpack_public_path__ + "static/media/messagesQuestion.acc59098757f740b2e67ef7408e60c8c.svg";
export { ForwardRef as ReactComponent };